import { render, staticRenderFns } from "./SellCategories.vue?vue&type=template&id=356ef3b8"
import script from "./SellCategories.vue?vue&type=script&lang=ts"
export * from "./SellCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356ef3b8')) {
      api.createRecord('356ef3b8', component.options)
    } else {
      api.reload('356ef3b8', component.options)
    }
    module.hot.accept("./SellCategories.vue?vue&type=template&id=356ef3b8", function () {
      api.rerender('356ef3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/SellCategories.vue"
export default component.exports